<template>
  <div class="chat-widget__header">
    <div class="chat-widget__header-column chat-widget__control-buttons">
      <HowTo/>
      <Button variant="text" type="button" icon="pi pi-plus" class="chat-widget__settings-button" label="Новый чат" @click="refreshPage" :disabled="!chatStore.dialog"/>
      <ExportComponent v-if="!appState.hideExportButton"/>
    </div>
    <DarkModeToggle class="chat-widget__header-column"/>
    <SocialList class="chat-widget__header-column" v-if="appState.showSocial"/>
  </div>
</template>
<script setup>
import Button from "primevue/button";
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {refreshPage} from "@/services/helper";
import {useChatStore} from "@/modules/chat/stores/chatStore";
import DarkModeToggle from "@/modules/chat/components/header/DarkModeToggle.vue";
import SocialList from "@/modules/chat/components/header/SocialList.vue";
import ExportComponent from "@/modules/chat/components/header/ExportComponent.vue";
import HowTo from "@/modules/chat/components/instruction/HowTo.vue";

const chatStore = useChatStore();
const appState = useAppStateStore();
</script>